/* tslint:disable */
/* eslint-disable */
/**
 * Committee Management API
 * The Law Society Committee Management Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { CommitteeContactDetail } from '../models';
import { CommitteeContactDetailRequest } from '../models';
import { CommitteeContactDetailResponse } from '../models';
import { CommitteeMemberIEnumerableResponse } from '../models';
import { CommitteeViewIEnumerableResponse } from '../models';
import { EmploymentDetail } from '../models';
import { EmploymentDetailResponse } from '../models';
import { EoiFormRequest } from '../models';
import { EoiFormViewResponse } from '../models';
import { FileIEnumerableResponse } from '../models';
import { LawIdUserIEnumerableResponse } from '../models';
import { MeetingPersonalNote } from '../models';
import { MemberDetail } from '../models';
import { MemberDetailCmaResponse } from '../models';
import { MemberDetailRequest } from '../models';
import { MemberDetailResponse } from '../models';
import { MyMeetingResponse } from '../models';
import { PersonalDetailCmaResponse } from '../models';
import { PersonalDetailResponse } from '../models';
import { Request } from '../models';
import { StringResponse } from '../models';
/**
 * MemberApi - axios parameter creator
 * @export
 */
export const MemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CMP | Returns My Committee Contact Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetCommitteeContactDetailGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/GetCommitteeContactDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns My Employment Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetEmploymentDetailGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/GetEmploymentDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns Committee Contact Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberCommitteeContactDetailLawIdGet: async (lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1MemberGetMemberCommitteeContactDetailLawIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMemberCommitteeContactDetail/{lawId}`
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns Member Personal Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberDetailLawIdGet: async (lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1MemberGetMemberDetailLawIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMemberDetail/{lawId}`
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns Employment Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberEmploymentDetailLawIdGet: async (lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1MemberGetMemberEmploymentDetailLawIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMemberEmploymentDetail/{lawId}`
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA ALL | Returns Members history
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberHistoryLawIdGet: async (lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1MemberGetMemberHistoryLawIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMemberHistory/{lawId}`
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns Member Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberPersonalDetailLawIdGet: async (lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1MemberGetMemberPersonalDetailLawIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMemberPersonalDetail/{lawId}`
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns Committee files by committeeId (Current Year)
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyCommitteeFilesCommitteeIdGet: async (committeeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1MemberGetMyCommitteeFilesCommitteeIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMyCommitteeFiles/{committeeId}`
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns my committees (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyCommitteesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/GetMyCommittees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns My EoiForm (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyEoiFormGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/GetMyEoiForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns a Meeting Detail by yearId, committeeId and meetingId
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyMeetingDetailsMeetingIdGet: async (meetingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1MemberGetMyMeetingDetailsMeetingIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMyMeetingDetails/{meetingId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns My Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyMemberDetailGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/GetMyMemberDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Save Personal note
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyPersonalNoteMeetingIdGet: async (meetingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1MemberGetMyPersonalNoteMeetingIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetMyPersonalNote/{meetingId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns My Personal Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetPersonalDetailGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/GetPersonalDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns whether a user is LSNSW staff or not (current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberIsLsNswStaffGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/IsLsNswStaff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns whether a user is new member or not (current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberIsNewMemberGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/IsNewMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns Email Preferences of Individuals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GetIndividualEmailPreferencesLawIdGet: async (lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1GetIndividualEmailPreferencesLawIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetIndividualEmailPreferences/{lawId}`
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns Areas of Interests for Individuals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GetIndividualAreasOfInterestLawIdGet: async (lawId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lawId' is not null or undefined
            if (lawId === null || lawId === undefined) {
                throw new RequiredError('lawId','Required parameter lawId was null or undefined when calling apiV1GetIndividualAreasOfInterestLawIdGet.');
            }
            const localVarPath = `/api/v1/Member/GetIndividualAreasOfInterest/{lawId}`
                .replace(`{${"lawId"}}`, encodeURIComponent(String(lawId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Save and Returns My Committee Contact Detail (Current)
         * @param {CommitteeContactDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveCommitteeContactDetailPost: async (body?: CommitteeContactDetail, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SaveCommitteeContactDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Save and Returns My Employment Detail (Current)
         * @param {EmploymentDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveEmploymentDetailPost: async (body?: EmploymentDetail, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SaveEmploymentDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin(Any committees) | Save and Returns Committee Contact Detail (Current)
         * @param {CommitteeContactDetailRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMemberCommitteeContactDetailPost: async (body?: CommitteeContactDetailRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SaveMemberCommitteeContactDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin(Any committees) | Save and Returns Member Detail (Current)
         * @param {MemberDetailRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMemberDetailPost: async (body?: MemberDetailRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SaveMemberDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Save My EoiForm (Current)
         * @param {EoiFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMyEoiFormPost: async (body?: EoiFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SaveMyEoiForm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns My Detail (Current)
         * @param {MemberDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMyMemberDetailPost: async (body?: MemberDetail, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SaveMyMemberDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Save Personal note
         * @param {MeetingPersonalNote} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMyPersonalNotePost: async (body?: MeetingPersonalNote, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SaveMyPersonalNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns Committees
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSearchLawIdUsersPost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Member/SearchLawIdUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemberApi - functional programming interface
 * @export
 */
export const MemberApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CMP | Returns My Committee Contact Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetCommitteeContactDetailGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeContactDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetCommitteeContactDetailGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns My Employment Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetEmploymentDetailGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmploymentDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetEmploymentDetailGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns Committee Contact Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMemberCommitteeContactDetailLawIdGet(lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeContactDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMemberCommitteeContactDetailLawIdGet(lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns Member Personal Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMemberDetailLawIdGet(lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberDetailCmaResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMemberDetailLawIdGet(lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns Employment Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMemberEmploymentDetailLawIdGet(lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmploymentDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMemberEmploymentDetailLawIdGet(lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA ALL | Returns Members history
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMemberHistoryLawIdGet(lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeMemberIEnumerableResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMemberHistoryLawIdGet(lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns Member Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMemberPersonalDetailLawIdGet(lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalDetailCmaResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMemberPersonalDetailLawIdGet(lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns Committee files by committeeId (Current Year)
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMyCommitteeFilesCommitteeIdGet(committeeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileIEnumerableResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMyCommitteeFilesCommitteeIdGet(committeeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns my committees (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMyCommitteesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMyCommitteesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns My EoiForm (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMyEoiFormGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EoiFormViewResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMyEoiFormGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns a Meeting Detail by yearId, committeeId and meetingId
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMyMeetingDetailsMeetingIdGet(meetingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyMeetingResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMyMeetingDetailsMeetingIdGet(meetingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns My Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMyMemberDetailGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMyMemberDetailGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Save Personal note
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetMyPersonalNoteMeetingIdGet(meetingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetMyPersonalNoteMeetingIdGet(meetingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns My Personal Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberGetPersonalDetailGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberGetPersonalDetailGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns whether a user is LSNSW staff or not (current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberIsLsNswStaffGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberIsLsNswStaffGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns whether a user is new member or not (current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberIsNewMemberGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberIsNewMemberGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns Email Preferences of Individuals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GetIndividualEmailPreferencesLawIdGet(lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1GetIndividualEmailPreferencesLawIdGet(lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns Areas of Interests of Individuals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GetIndividualAreasOfInterestLawIdGet(lawId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1GetIndividualAreasOfInterestLawIdGet(lawId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Save and Returns My Committee Contact Detail (Current)
         * @param {CommitteeContactDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSaveCommitteeContactDetailPost(body?: CommitteeContactDetail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeContactDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSaveCommitteeContactDetailPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Save and Returns My Employment Detail (Current)
         * @param {EmploymentDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSaveEmploymentDetailPost(body?: EmploymentDetail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmploymentDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSaveEmploymentDetailPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin(Any committees) | Save and Returns Committee Contact Detail (Current)
         * @param {CommitteeContactDetailRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSaveMemberCommitteeContactDetailPost(body?: CommitteeContactDetailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitteeContactDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSaveMemberCommitteeContactDetailPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin(Any committees) | Save and Returns Member Detail (Current)
         * @param {MemberDetailRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSaveMemberDetailPost(body?: MemberDetailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSaveMemberDetailPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Save My EoiForm (Current)
         * @param {EoiFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSaveMyEoiFormPost(body?: EoiFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSaveMyEoiFormPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns My Detail (Current)
         * @param {MemberDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSaveMyMemberDetailPost(body?: MemberDetail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberDetailResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSaveMyMemberDetailPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Save Personal note
         * @param {MeetingPersonalNote} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSaveMyPersonalNotePost(body?: MeetingPersonalNote, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSaveMyPersonalNotePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns Committees
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MemberSearchLawIdUsersPost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserIEnumerableResponse>> {
            const localVarAxiosArgs = await MemberApiAxiosParamCreator(configuration).apiV1MemberSearchLawIdUsersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MemberApi - factory interface
 * @export
 */
export const MemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary CMP | Returns My Committee Contact Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetCommitteeContactDetailGet(options?: any): AxiosPromise<CommitteeContactDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberGetCommitteeContactDetailGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns My Employment Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetEmploymentDetailGet(options?: any): AxiosPromise<EmploymentDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberGetEmploymentDetailGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns Committee Contact Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberCommitteeContactDetailLawIdGet(lawId: string, options?: any): AxiosPromise<CommitteeContactDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMemberCommitteeContactDetailLawIdGet(lawId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns Member Personal Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberDetailLawIdGet(lawId: string, options?: any): AxiosPromise<MemberDetailCmaResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMemberDetailLawIdGet(lawId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns Employment Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberEmploymentDetailLawIdGet(lawId: string, options?: any): AxiosPromise<EmploymentDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMemberEmploymentDetailLawIdGet(lawId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA ALL | Returns Members history
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberHistoryLawIdGet(lawId: string, options?: any): AxiosPromise<CommitteeMemberIEnumerableResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMemberHistoryLawIdGet(lawId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns Member Detail by LawId
         * @param {string} lawId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMemberPersonalDetailLawIdGet(lawId: string, options?: any): AxiosPromise<PersonalDetailCmaResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMemberPersonalDetailLawIdGet(lawId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns Committee files by committeeId (Current Year)
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyCommitteeFilesCommitteeIdGet(committeeId: number, options?: any): AxiosPromise<FileIEnumerableResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMyCommitteeFilesCommitteeIdGet(committeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns my committees (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyCommitteesGet(options?: any): AxiosPromise<CommitteeViewIEnumerableResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMyCommitteesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns My EoiForm (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyEoiFormGet(options?: any): AxiosPromise<EoiFormViewResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMyEoiFormGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns a Meeting Detail by yearId, committeeId and meetingId
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyMeetingDetailsMeetingIdGet(meetingId: number, options?: any): AxiosPromise<MyMeetingResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMyMeetingDetailsMeetingIdGet(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns My Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyMemberDetailGet(options?: any): AxiosPromise<MemberDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMyMemberDetailGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Save Personal note
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetMyPersonalNoteMeetingIdGet(meetingId: number, options?: any): AxiosPromise<StringResponse> {
            return MemberApiFp(configuration).apiV1MemberGetMyPersonalNoteMeetingIdGet(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns My Personal Detail (Current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberGetPersonalDetailGet(options?: any): AxiosPromise<PersonalDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberGetPersonalDetailGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns whether a user is LSNSW staff or not (current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberIsLsNswStaffGet(options?: any): AxiosPromise<BooleanResponse> {
            return MemberApiFp(configuration).apiV1MemberIsLsNswStaffGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns whether a user is new member or not (current)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberIsNewMemberGet(options?: any): AxiosPromise<BooleanResponse> {
            return MemberApiFp(configuration).apiV1MemberIsNewMemberGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Save and Returns My Committee Contact Detail (Current)
         * @param {CommitteeContactDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveCommitteeContactDetailPost(body?: CommitteeContactDetail, options?: any): AxiosPromise<CommitteeContactDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberSaveCommitteeContactDetailPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Save and Returns My Employment Detail (Current)
         * @param {EmploymentDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveEmploymentDetailPost(body?: EmploymentDetail, options?: any): AxiosPromise<EmploymentDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberSaveEmploymentDetailPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin(Any committees) | Save and Returns Committee Contact Detail (Current)
         * @param {CommitteeContactDetailRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMemberCommitteeContactDetailPost(body?: CommitteeContactDetailRequest, options?: any): AxiosPromise<CommitteeContactDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberSaveMemberCommitteeContactDetailPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin(Any committees) | Save and Returns Member Detail (Current)
         * @param {MemberDetailRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMemberDetailPost(body?: MemberDetailRequest, options?: any): AxiosPromise<MemberDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberSaveMemberDetailPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Save My EoiForm (Current)
         * @param {EoiFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMyEoiFormPost(body?: EoiFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return MemberApiFp(configuration).apiV1MemberSaveMyEoiFormPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns My Detail (Current)
         * @param {MemberDetail} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMyMemberDetailPost(body?: MemberDetail, options?: any): AxiosPromise<MemberDetailResponse> {
            return MemberApiFp(configuration).apiV1MemberSaveMyMemberDetailPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Save Personal note
         * @param {MeetingPersonalNote} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSaveMyPersonalNotePost(body?: MeetingPersonalNote, options?: any): AxiosPromise<BooleanResponse> {
            return MemberApiFp(configuration).apiV1MemberSaveMyPersonalNotePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns Committees
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MemberSearchLawIdUsersPost(body?: Request, options?: any): AxiosPromise<LawIdUserIEnumerableResponse> {
            return MemberApiFp(configuration).apiV1MemberSearchLawIdUsersPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MemberApi - object-oriented interface
 * @export
 * @class MemberApi
 * @extends {BaseAPI}
 */
export class MemberApi extends BaseAPI {
    /**
     * 
     * @summary CMP | Returns My Committee Contact Detail (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetCommitteeContactDetailGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetCommitteeContactDetailGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns My Employment Detail (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetEmploymentDetailGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetEmploymentDetailGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns Committee Contact Detail by LawId
     * @param {string} lawId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMemberCommitteeContactDetailLawIdGet(lawId: string, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMemberCommitteeContactDetailLawIdGet(lawId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns Member Personal Detail by LawId
     * @param {string} lawId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMemberDetailLawIdGet(lawId: string, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMemberDetailLawIdGet(lawId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns Employment Detail by LawId
     * @param {string} lawId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMemberEmploymentDetailLawIdGet(lawId: string, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMemberEmploymentDetailLawIdGet(lawId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA ALL | Returns Members history
     * @param {string} lawId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMemberHistoryLawIdGet(lawId: string, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMemberHistoryLawIdGet(lawId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns Member Detail by LawId
     * @param {string} lawId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMemberPersonalDetailLawIdGet(lawId: string, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMemberPersonalDetailLawIdGet(lawId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns Committee files by committeeId (Current Year)
     * @param {number} committeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMyCommitteeFilesCommitteeIdGet(committeeId: number, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMyCommitteeFilesCommitteeIdGet(committeeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns my committees (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMyCommitteesGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMyCommitteesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns My EoiForm (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMyEoiFormGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMyEoiFormGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns a Meeting Detail by yearId, committeeId and meetingId
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMyMeetingDetailsMeetingIdGet(meetingId: number, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMyMeetingDetailsMeetingIdGet(meetingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns My Detail (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMyMemberDetailGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMyMemberDetailGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Save Personal note
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetMyPersonalNoteMeetingIdGet(meetingId: number, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetMyPersonalNoteMeetingIdGet(meetingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns My Personal Detail (Current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberGetPersonalDetailGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberGetPersonalDetailGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns whether a user is LSNSW staff or not (current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberIsLsNswStaffGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberIsLsNswStaffGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns whether a user is new member or not (current)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberIsNewMemberGet(options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberIsNewMemberGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CMP | Returns Areas of Interests of Individuals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1GetIndividualEmailPreferencesLawIdGet(lawId: string, options?: any) {
        return MemberApiFp(this.configuration).apiV1GetIndividualEmailPreferencesLawIdGet(lawId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns Email preferences of a Individual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
        public apiV1GetIndividualAreasOfInterestLawIdGet(lawId: string, options?: any) {
            return MemberApiFp(this.configuration).apiV1GetIndividualAreasOfInterestLawIdGet(lawId, options).then((request) => request(this.axios, this.basePath));
        }
    
    /**
     * 
     * @summary CMP | Save and Returns My Committee Contact Detail (Current)
     * @param {CommitteeContactDetail} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSaveCommitteeContactDetailPost(body?: CommitteeContactDetail, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSaveCommitteeContactDetailPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Save and Returns My Employment Detail (Current)
     * @param {EmploymentDetail} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSaveEmploymentDetailPost(body?: EmploymentDetail, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSaveEmploymentDetailPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin(Any committees) | Save and Returns Committee Contact Detail (Current)
     * @param {CommitteeContactDetailRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSaveMemberCommitteeContactDetailPost(body?: CommitteeContactDetailRequest, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSaveMemberCommitteeContactDetailPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin(Any committees) | Save and Returns Member Detail (Current)
     * @param {MemberDetailRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSaveMemberDetailPost(body?: MemberDetailRequest, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSaveMemberDetailPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Save My EoiForm (Current)
     * @param {EoiFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSaveMyEoiFormPost(body?: EoiFormRequest, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSaveMyEoiFormPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns My Detail (Current)
     * @param {MemberDetail} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSaveMyMemberDetailPost(body?: MemberDetail, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSaveMyMemberDetailPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Save Personal note
     * @param {MeetingPersonalNote} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSaveMyPersonalNotePost(body?: MeetingPersonalNote, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSaveMyPersonalNotePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns Committees
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public apiV1MemberSearchLawIdUsersPost(body?: Request, options?: any) {
        return MemberApiFp(this.configuration).apiV1MemberSearchLawIdUsersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
